import React from "react";

import { FormControl } from "lib/index";
import createCompanySettingsView from "modules/settings/createCompanySettingsView";
import { stateSelector, initializeView, updateModel, submit } from "./index";
import Hint from "./MarketplaceSettingsHint";

const FormContent = ({ company, errors, handleCompanyPropChange, handleCompanyTranslationPropChange }) => (
  <div>
    <FormControl.FormGroup label={I18n.t("papp.settings.MarketplaceSettingsView.marketplace_homepage_url_label")}>
      <a href={company.getMarketplaceHomepageUrl()} target="_blank">
        {company.getMarketplaceHomepageUrl()}
      </a>
    </FormControl.FormGroup>

    <FormControl.InputFormGroup
      {...FormControl.addProps(`model.translations[${company.translation.uuid}].marketplace_name`, { errors })}
      value={company.translation.marketplace_name}
      onChange={handleCompanyTranslationPropChange.bind(null, company.translation, "marketplace_name")}
      label={I18n.humanAttributeName("company", "public_name")}
      placeholder={I18n.t("papp.common.default_value", {
        value: `${I18n.humanAttributeName("company", "name")} (${company.name})`,
      })}
    />

    <FormControl.InputFormGroup
      {...FormControl.addProps(`model.translations[${company.translation.uuid}].marketplace_short_description`, {
        errors,
      })}
      value={company.translation.marketplace_short_description}
      onChange={handleCompanyTranslationPropChange.bind(null, company.translation, "marketplace_short_description")}
      label={I18n.humanAttributeName("company", "short_description")}
      placeholder={I18n.humanAttributeName("company", "marketplace_short_description_placeholder")}
    />

    <FormControl.ImageAttachmentFormGroup
      {...FormControl.addProps(`model.marketplace_cover_image`, { errors })}
      value={company.marketplace_cover_image}
      onChange={handleCompanyPropChange.bind(null, "marketplace_cover_image")}
      label={I18n.humanAttributeName("company", "marketplace_cover_image")}
    />
  </div>
);

const MarketplaceSettingsView = createCompanySettingsView({
  stateSelector,
  actions: { initializeView, updateModel, submit },
  title: I18n.t("papp.settings.MarketplaceSettingsView.title"),
  FormContent,
  Hint,
});

export default MarketplaceSettingsView;



// WEBPACK FOOTER //
// ./src/modules/settings/MarketplaceSettingsView/MarketplaceSettingsView.jsx